import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private rootUrl: string = "/api/version";

  constructor(private httpClient: HttpClient) { }

  public getVersion(): Observable<string> {
    return this.httpClient.get(this.rootUrl, { responseType: 'text' });
  }
}
